// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lo7Ms","top":"styles_top__2-yXS","left":"styles_left__2vzLN","description":"styles_description__1SV3o"};